import type {
  Offering,
  PACKAGE_TYPE,
  Package,
  PurchaserInfo,
  SKProductDiscount,
  SubscriptionPeriod,
} from 'capacitor-purchases'
import {
  CapacitorPurchases,
} from 'capacitor-purchases'

import { isPlatform } from '@ionic/vue'

export interface IAPProductCustom {
  status: 'paid' | 'free'
  id_ios: string
  id_android: string
}

export const initIap = (id: string) => {
  if (isPlatform('capacitor')) {
    CapacitorPurchases.setDebugLogsEnabled({ enabled: import.meta.env.DEV }) // Enable to get debug logs in dev mode
    CapacitorPurchases.setup({ apiKey: id })
  }
}

export const restore = async (): Promise<PurchaserInfo | null> => {
  if (!isPlatform('capacitor'))
    return null
  const res = await CapacitorPurchases.restoreTransactions()
  const purchaserInfo = res.purchaserInfo
  // console.log('restore', res)
  const ids: string[] = []
  const idsOld: string[] = []
  purchaserInfo.activeSubscriptions.forEach((id) => {
    ids.push(id)
  })
  purchaserInfo.allPurchasedProductIdentifiers.forEach((id) => {
    idsOld.push(id)
  })
  return purchaserInfo
}

export const purchase = async (p: Package): Promise<PurchaserInfo | null> => {
  try {
    // console.log('purchase', p)
    const data = await CapacitorPurchases.purchasePackage({
      identifier: p.identifier,
      offeringIdentifier: p.offeringIdentifier,
    })
    // console.log('listenBuy', data)
    const purchaserInfo = data.purchaserInfo
    return purchaserInfo
  }
  catch (e) {
    console.error('listenBuy error', e)
  }
  return null
}

export const getCurrentOfferings = async (): Promise<Offering | null> => {
  const { offerings } = await CapacitorPurchases.getOfferings()
  // return offerings ? offerings.all['default'] : null // for debug only
  return offerings ? offerings.current : null
}

export const findPackage = async (
  productId: string,
): Promise<Package | null> => {
  if (!isPlatform('capacitor')) {
    return {
      identifier: 'abcd',
      offeringIdentifier: 'abcd',
      packageType: 'ANNUAL' as PACKAGE_TYPE,
      product: {
        identifier: 'abcd',
        subscriptionGroupIdentifier: 'abcd',
        description: 'xyz',
        title: 'ABCD',
        price: 14.99,
        priceString: '$14.99',
        currencyCode: 'EU',
        currencySymbol: '€',
        isFamilyShareable: false,
        subscriptionPeriod: {} as SubscriptionPeriod,
        introductoryPrice: {} as SKProductDiscount,
        discounts: [] as SKProductDiscount[],
      },
      // subscriptionGroupIdentifier: string,
      // subscriptionPeriod: SubscriptionPeriod,
      // introductoryPrice: SKProductDiscount,
      // discounts: SKProductDiscount,
    }
  }
  const offering = await getCurrentOfferings()
  if (!offering)
    return null
  for await (const p of offering.availablePackages) {
    if (p.product.identifier === productId)
      return p
  }
  return null
}
export const isAnyActiveSub = (
  productIds: string[],
  pInfo: PurchaserInfo | null,
): boolean => {
  let activeSub = false
  if (pInfo && pInfo.activeSubscriptions.length && productIds)
    activeSub = pInfo.activeSubscriptions.some(id => productIds.includes(id))

  // console.log('isPurchased', productIds, pInfo, activeSub)
  return activeSub
}
export const isPurchased = (
  productId: string,
  pInfo: PurchaserInfo | null,
): boolean => {
  let purchased = false
  if (pInfo && productId) {
    purchased = pInfo.allPurchasedProductIdentifiers.includes(
      productId,
    )
  }
  // console.log('isPurchased', productId, pInfo, purchased)
  return purchased
}
